import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateSystemSettingsMutation, UpdateSystemSettingsMutationVariables } from '@/graphql/generated/graphql';
import { UpdateSystemSettingsDocument } from '@/graphql/generated/graphql';
export type SystemSettingsUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  Key?: string
  Value?: string
  Description?: string
}

export type UpdateSystemSettingsResponse = {
  data: {
    updateSystemSettings: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateSystemSettings = () => {
  const mutation = useMutation({
    mutationKey: ['update-system-settings'],
    mutationFn: (variables: SystemSettingsUpdateInput) => {
      return graphqlClient.request<UpdateSystemSettingsMutation>(UpdateSystemSettingsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateSystemSettings: mutation.mutate,
    updateSystemSettingsAsync: mutation.mutateAsync,
  }
}

export const UPDATE_SYSTEM_SETTING_MUTATION = UpdateSystemSettingsDocument;
